export default ({ s, facade }: { s?: number | string, facade: string }) => {
  if (facade) {
    return Array((s ? s.toString().length : 0) + 1).fill(facade).join('')
  }
  return null
}